import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-branch-address-details',
  templateUrl: './psa-branch-address-details.component.html',
  styleUrls: ['./psa-branch-address-details.component.css']
})
export class PsaBranchAddressDetailsComponent implements OnInit {
  title="Branch Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-branch-address-details/psa-branch-address-details.component.ts